/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateSocialPostSuccessResponse
 */
export interface ValidateSocialPostSuccessResponse {
    /**
     * 
     * @type {boolean}
     * @memberof ValidateSocialPostSuccessResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof ValidateSocialPostSuccessResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateSocialPostSuccessResponse
     */
    platform: string;
    /**
     * 
     * @type {string}
     * @memberof ValidateSocialPostSuccessResponse
     */
    canonicalUrl?: string;
}

/**
 * Check if a given object implements the ValidateSocialPostSuccessResponse interface.
 */
export function instanceOfValidateSocialPostSuccessResponse(value: object): value is ValidateSocialPostSuccessResponse {
    if (!('success' in value) || value['success'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('platform' in value) || value['platform'] === undefined) return false;
    return true;
}

export function ValidateSocialPostSuccessResponseFromJSON(json: any): ValidateSocialPostSuccessResponse {
    return ValidateSocialPostSuccessResponseFromJSONTyped(json, false);
}

export function ValidateSocialPostSuccessResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateSocialPostSuccessResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'],
        'id': json['id'],
        'platform': json['platform'],
        'canonicalUrl': json['canonicalUrl'] == null ? undefined : json['canonicalUrl'],
    };
}

export function ValidateSocialPostSuccessResponseToJSON(json: any): ValidateSocialPostSuccessResponse {
    return ValidateSocialPostSuccessResponseToJSONTyped(json, false);
}

export function ValidateSocialPostSuccessResponseToJSONTyped(value?: ValidateSocialPostSuccessResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'id': value['id'],
        'platform': value['platform'],
        'canonicalUrl': value['canonicalUrl'],
    };
}

